<style>
    .adjust-product-tips {
        position: absolute;
        top:0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(255,255,255,.9);
        color: #48576a;
    }
    .adjust-total-amount {
        border:1px solid #dfe6ec;
        border-top: 0;
        text-align: right;
        color: #48576a;
        font-size: 12px;
        padding: 8px 50px;
    }
</style>
<template>
    <div class="p20">
        <!-- 头部按钮部分 start -->
        <div class="el-row ly-bill-title">
            <el-col :span="12">
                <h1 style="padding-top:5px;">新增采购差额调账单</h1>
            </el-col>
            <el-col :span="12" class="tr">
                <el-button type="primary" @click="submit" size="small"  :loading="submitLoad">
                    <i class="fa fa-save" v-if="!submitLoad"></i>&nbsp;提交
                </el-button>
                <ly-router-button size="small">
                    <i class="fa fa-chevron-left"></i>&nbsp;返回
                </ly-router-button>
            </el-col>
        </div>
        <!-- 头部按钮部分 end -->
        <!-- 表单列表 start -->
        <el-card class="box-card mt15">
            <Ly-search-form 
                :config="formConfig" 
                :rules="formRules"
                :is-search="false"
                label-width="120px"
                ref="searchForm"
                v-model="formValue">
            </Ly-search-form>
        </el-card>
        <!-- 表单列表 end -->

        <!-- 商品选择组件 start -->
        <el-card class="box-card mt15 pr" ref="productCard" v-if="!loading"> 
            <ly-product-table 
                ref="productTable"
                :is-batch="true"
                :other="formValue"
                :thead-config="productConfig"
                batch-type="18"
                v-model="submitForm.productList">
                <div class="adjust-total-amount">
                    调账差额合计: {{totalAmount}}
                </div>
            </ly-product-table>
            <div class="adjust-product-tips" v-if="userInfo.is_fencang == 1 && formValue.warehouse_id <= 0">
                <div class="flex f1 center h100b">
                    请先选择仓库
                </div>
            </div>
        </el-card>
        <!-- 商品选择组件 end -->
    </div>
</template>
<script>
    import AddFormConfig from './add-form'
    import AddProductConfig from './add-product'
    import AddRulesConfig from './rules'

    import LySearchForm from '@c/search-form'
    import LyRouterButton from '@c/router-button'
    import LyProductTable from '@c/product-table'

    import {mapGetters, mapActions} from 'vuex'
    export default {
        mixins: [
            AddFormConfig,
            AddProductConfig,
            AddRulesConfig
        ],
        components: {
            LySearchForm,
            LyRouterButton,
            LyProductTable
        },
        computed: {
            ...mapGetters([
                'userInfo'     
            ]),
            ...mapGetters('bill', [
                'copyInfo'
            ]),
            // 总的贴损金额，顺便将总的理赔金额 在这计算了
            totalAmount () {
                let total = 0 
                this.submitForm.productList.forEach(function (el) {
                    // 计算总的贴损金额
                    if (el.tzce_amount && !isNaN(el.tzce_amount)) {
                        total = (parseFloat(total) + parseFloat(el.tzce_amount)).toFixed(2)
                    }
                }, this)
                return total
            }
        },
        data () {
            return {
                loading: true,
                submitLoad: false, // 提交按钮的状态标识
                // 表单输入内容
                formValue: {},
                submitForm: {
                    uuid: '',
                    productList: []
                } // 提交的表单数据
            }
        },
        mounted () {
            // 有复制数据的时候
            if (this.copyInfo && this.copyInfo.path && this.copyInfo.path === 'adjust') {
                this.queryEditData(this.copyInfo.id)
            } else {
                // 设置UUID
                this.submitForm.uuid = this.$utils.createUUID()
                // 初始设置制作单人
                this.initData()
                this.loading = false
            }
        },
        methods: {
            ...mapActions('bill', [
                'clearCopyInfo'
            ]),
            /**
             * 获取要修改的数据
             */
            queryEditData (id) {
                this.$api.queryArr(['api/caigoucetz', 'edit'], null, [id]).then((rs) => {
                    this.submitForm = rs
                    // 设置表单中的回填数据
                    this.$refs['searchForm'].initBindFormData(rs)
                    // 设置UUID
                    this.submitForm.uuid = this.$utils.createUUID()
                    // 清空复制
                    this.clearCopyInfo()
                    // 取消加载
                    setTimeout(() => {
                        this.loading = false
                    }, 100)
                }).catch((error) => {
                    // 取消加载
                    this.loading = false
                    this.$message({
                        message: error,
                        type: 'warning'
                    })
                })
            },
            /**
             * 初始化的数据设置
             */
            initData () {
                // 初始设置制作单人、收胎人
                this.$refs['searchForm'].initBindFormData({
                    department_name: this.userInfo.department_name,
                    zhidan_name: this.userInfo.name
                })
            },
            submit () {
                let productList = this.$refs['productTable'].getProductData()
                if (this.$refs['searchForm'].validateForm()) {
                    // 判断起始截止日期 修改于2019-7-5
                    if (this.formValue.date_end < this.formValue.date_start) {
                        this.$message({
                            message: '截止日期必须超过起始日期！',
                            type: 'warning'
                        })
                        return false
                    } 
                    if (productList && productList.length > 0) {
                        // 货品验证
                        let productMsg = this.validateProduct(productList)
                        // 货品验证不通过的情况
                        if (productMsg.length > 0) {
                            this.$alert(productMsg, '货品录入提示', {
                                confirmButtonText: '确定'
                            })
                        } else {
                            this.submitLoad = true
                            // 获得得查询的字段
                            this.submitForm = Object.assign(this.submitForm, this.$refs['searchForm'].bindForm)
                            // 表单中写入货品列表
                            this.submitForm['productList'] = productList
                            // 提交数据
                            this.$api.create('api/caigoucetz',this.submitForm).then((rs) => {
                                this.$alert('数据提交成功', '新增', {
                                    confirmButtonText: '确定',
                                    callback: action => {
                                        this.submitLoad = false
                                        // 跳转到详情页面
                                        this.$router.push('/bill/adjust/info/' + rs.id)
                                    }
                                });
                                // 更新UUID
                                this.submitForm.uuid = this.$utils.createUUID()
                            }).catch((error) => {
                                this.submitLoad = false
                                this.$message({
                                    message: error,
                                    type: 'warning'
                                })
                            })
                        }
                    } else {
                        this.$message({
                            message: '请添加货品',
                            type: 'warning'
                        })
                    }                    
                } else {
                    this.$message({
                        message: '请将信息填写完整',
                        type: 'warning'
                    })
                }
            }
        }
    }
</script>